import React, { lazy } from 'react'
import Loadable from '../../components/Loadable/Loadable'
import { Page } from '../../Pages'
import { ShowIfRole } from '../../auth/AuthGuard'

const UsersPage = Loadable(lazy(() => import('./Users')))

const usersRoutes = [
	{
		path: Page.users.path,
		element: (
			<ShowIfRole role={Page.users.auth}>
				<UsersPage />
			</ShowIfRole>
		),
		auth: Page.users.auth
	}
]

export default usersRoutes
